import { DialogContent, DialogActions } from '@mui/material';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { CardsPreviewGroup } from '@shared/ui/parts';
import { useTranslation } from 'react-i18next';
import { useCards } from '@app/api/cards/useCards';
import { useState } from 'react';
import { cardStatuses } from '@utils/statuses';

export default function BlockCardDialog({ close, data }) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const { blockCards } = useCards();

  const availableCards = data.filter(
    (item) => cardStatuses[item?.status] !== 'blocked',
  );

  async function onSubmit() {
    setIsLoading(true);
    try {
      const res = await blockCards({
        card_ids: availableCards.map((x) => x.id),
      });
      if (res) close();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <DialogContent>
        <CardsPreviewGroup
          data={availableCards}
          label={t('are_you_sure_block_cards')}
        />
        <br />
        <Note
          type="warning"
          title={t('this_operation_cannot_be_undone')}
          content={t('cards_block_note')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="block-outline"
            onClick={onSubmit}
            loading={isLoading}
          >
            {t('yes_block')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
